import React from 'react';
import { FileText, Shield, Scale } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <div className="text-sm text-gray-600">© {currentYear} Qualiz. All rights reserved.</div>

          {/* Legal Links */}
          <div className="flex items-center gap-6">
            <a
              href="/terms-and-conditions.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <FileText className="w-4 h-4" />
              <span>Terms & Conditions</span>
            </a>
            <a
              href="/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <Shield className="w-4 h-4" />
              <span>Privacy Policy</span>
            </a>
            <a
              href="/gdpr-compliance.html"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-indigo-600 transition-colors"
            >
              <Scale className="w-4 h-4" />
              <span>GDPR Compliance</span>
            </a>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-4 text-center text-xs text-gray-500">
          Made with care for educators and students worldwide
        </div>
      </div>
    </footer>
  );
}
